import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChange } from '@angular/core';

// import { d4dbService  } from '../../services/d4db.service';

import * as d3 from 'd3';
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;
//  import * as dbox from '@dboxjs/core';
declare var dbox: any
import * as _ from 'lodash';

@Component({
  selector: 'dbox-scatter',
  templateUrl: './dboxScatter.component.html',
  styleUrls: ['./dboxScatter.component.scss']
})
export class DboxScatterComponent implements OnInit, OnChanges {
  @Input() colors;
  @Input() topic;
  @Input() selectedOne;
  @Input() selectedTwo;
  @Output() onTopicChange = new EventEmitter();
  chartData: any = {};
  vm;
  xTopic = 'opacidad';

  ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
    for (const propName of Object.keys(changes)) {
      const changedProp = changes[propName];
      const to = JSON.parse(JSON.stringify(changedProp.currentValue));
      if (changedProp.isFirstChange()) {
        // console.log(`Initial value of ${propName} set to ${to}`);
        // this.draw()
      } else {
        const from = JSON.stringify(changedProp.previousValue);
        console.log(`${propName} changed from ${from} to ${to}`);
        if (propName === 'selectedOne' && to !== null && to.by !== 'scatter') {
          this.draw();
        }
        if (propName === 'selectedTwo' && to !== null && to.by !== 'scatter') {
          this.draw();
        }
        if (propName === 'topic' && to !== null && to.by !== 'scatter') {
          this.draw();
        }
        // if(propName == 'hover' && to !== null && to.by !== 'bars') this.select(to);
        // if(propName == 'unhover'&& to !== null  && to.by !== 'bars') this.unselect(to);
      }
    }

  }

  /**
   * ngOnInit: Init component, gets municipality data and stores it on chartData,
   * gets data from escuelas_localidad.csv and stores it in mun_localities
   * then draws Localities Scatter
   * @since v2
  */
  ngOnInit() {
    this.draw()
  }

  draw() {
    const vm = this;
    const format = d3.format('.0f');
    const scatterW = $('#scatter').width(); // Getting scatter container size
    const config = {
      'bindTo': '#scatter',
      'size': {
        'width': scatterW,
        'height': 445,
        'margin': {top: 40, right: 25, bottom: 25, left: 100},
      },
      'xAxis': {
        'enabled': true,
        'scale': 'linear',
        'text': '',
        'domain': {
          'enabled': true,
          'stroke': '#646464',
          'stroke-width': '3'
        },
        'dropdown': {
          'enabled': true,
          'options': [
            {
              'title': 'Coeficiente TAI (Transparencia, Anticorrupción, Impunidad)',
              'value': 'coeficiente_TAI',
              'selected': vm.xTopic && vm.xTopic === 'coeficiente_TAI' ? true : false
            },
            {
              'title': 'Opacidad: Métrica de Gobierno Abierto 2017 (CIDE)',
              'value': 'opacidad',
              'selected': vm.xTopic && vm.xTopic === 'opacidad' ? true : false
            },
            {
              'title': 'Corrupción: Tasa de prevalencia de la corrupción 2015 (INEGI)',
              'value': 'corrupcion',
              'selected': vm.xTopic && vm.xTopic === 'corrupcion' ? true : false

            },
            {
              'title': 'Impunidad: Índice Global de Impunidad 2016 (UDLAP)',
              'value': 'impunidad',
              'selected': vm.xTopic && vm.xTopic === 'impunidad' ? true : false
            }
          ],
          'styles': {
            'background-color': this.getColor(),
            'width': '353px',
            'height': '46px',
            'color': '#FFFFFF',
            'border-radius': '10px',
            'margin-top': '25px',
            'font-size': '12px'
          }
        }
      },
      'yAxis': {
        'enabled': true,
        'scale': 'linear',
        // 'tickValues': totalSchools,
        'tickFormat': format,
        'text': '',
        'domain': {
          'enabled': false
        },
        'ticks': {
          'enabled': true,
          'style': 'dashLine'
        },
        'dropdown': {
          'enabled': true,
          'options': [
            {
              'title': 'Coeficiente TAI (Transparencia, Anticorrupción, Impunidad)',
              'value': 'coeficiente_TAI',
              'selected': vm.topic && vm.topic === 'coeficiente_TAI' ? true : false
            },
            {
              'title': 'Opacidad: Métrica de Gobierno Abierto 2017 (CIDE)',
              'value': 'opacidad',
              'selected': vm.topic && vm.topic === 'opacidad' ? true : false
            },
            {
              'title': 'Corrupción: Tasa de prevalencia de la corrupción 2015 (INEGI)',
              'value': 'corrupcion',
              'selected': vm.topic && vm.topic === 'corrupcion' ? true : false
            },
            {
              'title': 'Impunidad: Índice Global de Impunidad 2016 (UDLAP)',
              'value': 'impunidad',
              'selected': vm.topic && vm.topic === 'impunidad' ? true : false
            }
          ],
          'styles': {
            'background-color': this.getColor(),
            'width': '353px',
            'height': '45px',
            'color': '#FFFFFF',
            'border-radius': '10px',
            'margin-top': '25px',
            'font-size': '12px'
          }
        }
      },
      'events': {
        'load': function(c){
          const chart = c;
          d3.selectAll('.state-tip-scatter').remove();

          d3.select('#scatter .scatter-33').style('fill', '#00B7B7')
          d3.select('#scatter .scatter-33').style('fill', '#26ede7')
          d3.select('#scatter .scatter-33').style('stroke', '#00B7B7')
          d3.select('#scatter .scatter-33').style('stroke-dasharray', '3,2')
          // d3.select('.d3-tip.n .scatter-33').style('background-color','#00B7B7');

          if (vm.selectedOne) {
            d3.select('#scatter .scatter-' + vm.selectedOne.d.CVE_ENT).style('fill', '#894c93')
            d3.select('#scatter .scatter-' + vm.selectedOne.d.CVE_ENT).style('stroke', '#6B1E74')
            // d3.select('.d3-tip.n .scatter-'+vm.selectedOne.d.CVE_ENT).style('background-color','#6B1E74')
          }

          if (vm.selectedTwo) {
            d3.select('#scatter .scatter-' + vm.selectedTwo.d.CVE_ENT).style('fill', '#c39156')
            d3.select('#scatter .scatter-' + vm.selectedTwo.d.CVE_ENT).style('stroke', '#CEA052')
            // d3.select('.d3-tip.n .scatter-'+vm.selectedTwo.d.CVE_ENT).style('background-color','#CEA052')
          }
          // looping through each circle in Scatter and selecting the ones with different Color
          d3.select('#scatter svg')
            .selectAll('circle')
            .each(function(d, i){
              const datum: any = d;
              let stateTip = d3Tip()
                .attr('class', 'state-tip-scatter')
                .attr('id', function() {
                  return 'state-' + datum.datum.CVE_ENT;
                })
                .html(function (d) {
                  let html = '<span>' + d.datum.NOM_ENT + '</span><br>';
                  html += '<span>(' + Number(d.datum[y]).toFixed(1) + ', ' + Number(d.datum[vm.xTopic]).toFixed(1) + ')</span>';
                  return html;
                });
              d3.select('#scatter svg').call(stateTip);
              // if it isnt National or grey show Tooltip
              if (i !== 32 && d3.select(this).attr('style') !== 'fill: rgb(177, 177, 188); opacity: 1;') {
                stateTip.show(d, d3.select(this).node());
              }
            });

          d3.select('#scatter .dbox-xAxis-select')
            .style('margin-top', '10px')
            .style('margin-left', '64px');

          d3.select('#scatter .dbox-yAxis-select')
            .style('height', '24px')
            .style('margin-top', '10px');

          d3.selectAll('#scatter .y.axis .tick line')
            .attr('stroke', '#b2b6c5')
            .style('stroke-linecap', 'round')
            .style('stroke-width', '2')
            .style('stroke-dasharray', '5,8')

          d3.selectAll('#scatter .y.axis .tick text')
            .attr('x' , -10)
            .style('fill', '#96a1a3')
            .style('font-family', '"Open Sans", sans-serif')
            .style('font-size', '12px').style('font-weight', '400')

          d3.selectAll('#scatter .x.axis .tick text')
            .attr('y', 12)
            .attr('fill', '#96a1a3')
            .style('font-family', '"Open Sans", sans-serif')
            .style('font-size', '12px').style('font-weight', '400')

          // Bring .domain to front
          d3.select('#scatter .x.axis').select('.domain').raise();
          d3.select('#scatter .x.axis').raise();

        },
        'change': function(c){
          const chart = c;
          vm.onTopicChange.emit({'topic': c._config.y});
          vm.xTopic = c._config.x
        }
      }
    }

    const y = vm.topic  ? vm.topic : 'coeficiente_TAI';
    const chart = dbox.chart(config)
        .data({'csv': 'assets/data/coeficienteTAI.csv'})
      .layer(dbox.scatter)
        .id('CVE_ENT')
        .x(vm.xTopic)
        .y(y)
        .color('#B1B1BC')
        .tip(function(d) {
          let html = '<span>' + d.datum.NOM_ENT + '</span><br>';
          html += '<span>(' + Number(d.datum[y]).toFixed(1) + ', ' + Number(d.datum[vm.xTopic]).toFixed(1) + ')</span>';
          return html;
        })
      .end()
        .draw();
  }

  getColor() {
    switch (this.topic) {
      case 'coeficiente_TAI':
        return '#8B3E65';
      case 'opacidad':
        return '#e5640c';
      case 'corrupcion':
        return '#006b5a';
      case 'impunidad':
        return '#112f70';
    }
  }

  selectedTopic(data) {
    let actualClass = d3.select('.nav-extended .tabs-transparent .active').attr('class');
    let actual = actualClass.split(' ');
    switch (actual[0]) {
      case 'coeficiente_TAI':
        return data[0].coeficiente_TAI;
      case 'corrupcion':
        return data[0].corrupcion;
      case 'impunidad':
        return data[0].impunidad;
      case 'opacidad':
        return data[0].opacidad;
    }
  }
}



// WEBPACK FOOTER //
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxScatter/dboxScatter.component.ts